<template>
  <v-footer app>
    <span>&copy; 2020 دکورآرای</span>
  </v-footer>
</template>

<script>
export default {}
</script>

<style scoped>
/* RTL Footer styles */
.v-footer {
  direction: rtl;
  text-align: right;
}
</style>
